/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
export type AgentChatMessageFragment = {
  readonly __typename: "AgentChatMessage";
  readonly id: c.AgentChatMessageId;
  readonly role: Types.MessageRole;
  readonly staticId: c.StaticAgentChatMessageId;
  readonly revision: number;
  readonly content: ReadonlyArray<c.MessageContentBlock | null>;
  readonly createdDate: c.DateTimeString;
  readonly agentChatThreadId: c.AgentChatThreadId;
  readonly runId: c.AgentChatRunId;
  readonly debugInfo: c.AgentChatMessageDebugInfo | null;
  readonly invokedByThreadId: c.AgentChatThreadId | null;
};

export const AgentChatMessageFragmentDoc = /*#__PURE__*/ gql`
  fragment AgentChatMessageFragment on AgentChatMessage {
    id
    role
    staticId
    revision
    content
    createdDate
    agentChatThreadId
    runId
    debugInfo
    invokedByThreadId
  }
`;
